module.exports = __webpack_public_path__ + "videos/gradient-map_jp.5bd879a.mp4";